import * as Sentry from '@sentry/react';
import { TriangleAlertIcon } from 'lucide-react';
import { useEffect, type JSX } from 'react';
import { useNavigate } from '@tanstack/react-router';
import type { ErrorComponentProps } from '@tanstack/react-router';

import { Button } from '@/components/atoms/button';
import { StatusPage } from '@/components/layout/status-page';

export function ErrorPage({ error, reset }: ErrorComponentProps): JSX.Element {
  const navigate = useNavigate();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <StatusPage
      variant="full"
      title="Something went wrong"
      description="An unexpected error occurred. You can try again or return to the home page."
      icon={<TriangleAlertIcon size={48} strokeWidth={1.5} />}
      actions={
        <>
          {reset ? (
            <Button variant="default" type="button" onClick={reset}>
              Try again
            </Button>
          ) : null}
          <Button
            variant="info"
            type="button"
            onClick={() => navigate({ to: '/documents' })}
          >
            Go to home
          </Button>
        </>
      }
    />
  );
}
